export const TransportModalTypes = {
    MULTI: "MULTI",
    INTERMODAL: "INTERMODAL"
}

export const transport_type_to_vehicle_id_mapping = {
    'pendlerportal': 'car',
    'rideAndBikesharing': 'train',
    'rideAndBike': 'train',
    'carsharing': 'car',

    'eCarsharing': 'ecar',
    'rideAndCarsharing': 'train',
    'rideAndCar': 'train',
    'bikesharing': 'bike',
    'eBikesharing': 'ebike',
    'bikescooter': 'bikescooter',
    'eScootersharing': 'escooter',
    'rideAndScooter': 'train',
    'rideAndeScooter': 'train',
    'eScooter': 'escooter',
    'bike': 'bike',
    'car': 'car',
    'eCar': 'ecar',
    'eBike': 'ebike',
    'rideAndTaxi': 'train',
    'walk': 'walk',
    'train': 'train',
    'trainRegio': 'train',
    'taxi': 'car',
    'carpooling': 'car',
    'intermodalCarpooling': 'car',
    'werksbus': 'bus_long_distance'
}

export const TransportTypesMaterialsDict = {
    rideAndBikesharing: ['directions_walk', 'train', 'bike'],
    rideAndBike: 'rideAndBike',
    carsharing: 'carsharing',
    rideAndCarsharing: 'rideAndCarsharing',
    rideAndCar: 'rideAndCar',
    bikesharing: 'bike',
    bike: 'directions_bike',
    car: 'car_rental',
    eCar: 'eCar',
    eBike: 'electric_bike',
    rideAndTaxi: 'rideAndTaxi',
    walk: 'walk',
    train: 'train',
    trainRegio: 'trainRegio',
    taxi: 'taxi'
}

export const OEPVmodes = ['bus',
    'tram',
    'suburban',
    'subway',
    'ferry',
    'express',
    'nationalExpress',
    'regional',
    'national',
    'regionalExpress',
    'foot']
